import { acceptHMRUpdate, defineStore } from "pinia";

export const useMenuStore = defineStore("menu", () => {
  const active = ref("");

  return {
    active
  }
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useMenuStore, import.meta.hot));